import { render, staticRenderFns } from "./limitsReserch1.vue?vue&type=template&id=394f2574"
import script from "./limitsReserch1.vue?vue&type=script&lang=js"
export * from "./limitsReserch1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports